import React, { useRef } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api'
import { projectFormLocationSelector, setProjectFormItemValue } from 'src/features'
import ProjectFormLocationAutoComplete from './ProjectFormLocationAutoComplete/ProjectFormLocationAutoComplete'

const ProjectFormGoogleMapLocation: React.FC = () => {
  const dispatch = useAppDispatch()
  const { latitude, longitude } = useAppSelector(projectFormLocationSelector)
  const mapRef = useRef(null)
  const handleLoad = (map: any) => mapRef.current = map

  const position = { lat: +(latitude || 0), lng: +(longitude || 0) }

  const containerStyle = {
    height: '25vh',
    width: '100%',
    borderRadius: '10px'
  }

  const updatePosition = (value: {lat: Function, lng: Function}) => {
    dispatch(setProjectFormItemValue({ key: 'latitude', value: value.lat() }))
    dispatch(setProjectFormItemValue({ key: 'longitude', value: value.lng() }))
  }


  return (
    <>
      <div className='full-width'>
        <LoadScript googleMapsApiKey={process.env.MAPS_API_KEY} libraries={['places']}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            zoom={2}
            onLoad={handleLoad}
            center={position}
          >
            <Marker
              position={position}
              draggable
              onDrag={(e) => updatePosition(e.latLng)}
            />
          </GoogleMap>

          <ProjectFormLocationAutoComplete />
        </LoadScript>
      </div>
    </>
  )
}

export default ProjectFormGoogleMapLocation
